import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import Home from './pages/Home';
import About from './pages/About';
import CVPage from './pages/CVPage';
import Collaborators from './pages/Collaborators';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import { SHOW_COLLABORATORS } from './config';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header></Header>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/cv" element={<CVPage />}></Route>
          {SHOW_COLLABORATORS &&
            <Route path="/collaborators" element={<Collaborators />}></Route>}
          <Route path="/impressum" element={<Impressum />}></Route>
          <Route path="/datenschutz" element={<Datenschutz />}></Route>
        </Routes>
        <Footer></Footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
